// Handle Accordions
document.addEventListener('DOMContentLoaded', function () {
  // Select all accordion titles
  var acc = document.getElementsByClassName('accordion__title');

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      // Toggle the "active" class on the clicked accordion
      this.parentElement.classList.toggle('active');
    });
  }

  // Bugfix: remove the display none style attribute from judgeMe
  setTimeout(() => {
    let widgetActionsWrapper = document.querySelector('.jdgm-widget-actions-wrapper a');

    if (widgetActionsWrapper) {
      widgetActionsWrapper.style.display = 'block';
    }
  }, 3000);
});

String.prototype.escapeSpecialChars = function() {
  return this.replace('\'', '\\\'');
};